import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_USER + '/permission/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_USER + '/permission/update_status',
    method: 'post',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_USER + '/permission/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_USER + '/permission/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_USER + '/permission/update',
    method: 'put',
    data: data
  })
}

export function getPermissionList() {
  return request({
    url: process.env.BASE_URL_USER + '/common/permission/list',
    method: 'get'
  })
}






// WEBPACK FOOTER //
// ./src/api/permission.js